import React, {ChangeEvent, FC} from "react";
import {createStyles, CSSProperties, makeStyles} from '@mui/styles';
// import {NewButton} from "../../NewButton";
import {Button, Theme} from "@mui/material";


const useStyles = makeStyles((theme: Theme) => (
    createStyles({
        root: {
            '& > *': {
                margin: theme.spacing(1),
            },
        },
        input: {
            display: 'none',
        },
        button: {
            boxShadow: "none",
            width: '137px',
            height: '35px',
            fontWeight: 600,
            fontSize: '16px',
            borderRadius: '25px',
            color: 'white',
            // '&:hover': {
            //     // color: 'white'
            // }
        }
    })
));

type PropsType = {
    id: string;
    func?: () => void;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    accept?: string,
    small?: boolean,
    sx?: CSSProperties,
    text?: string,
    revDir? : boolean,
    variant?: "outlined" | "contained" | 'text' | undefined,
    margin?: string,
    // fontColor?: string,
    size?: 'small' | 'large' | 'medium'
}
export const UploadFileBTN: FC<PropsType> = ({func, id, onChange, accept, small, sx, text, revDir = false, variant = 'contained', margin, size = 'large'}: PropsType) => {
    const classes = useStyles();

    return (
        <div onClick={e => {
            e.stopPropagation();
        }}>
            <input
                id={"contained-button-file " + id}
                type="file"
                accept={accept || ''}
                className={classes.input}
                onChange={async e => {
                    await onChange(e);
                }}
            />
            <label htmlFor={"contained-button-file " + id}>
                {small
                    ?
                    <Button
                        variant={variant}
                        component={'span'}
                        size={'small'}
                        sx={{...sx}}
                    >
                        {text ? text : 'Upload'}
                    </Button>
                    :
                    <Button
                        variant={variant}
                        component={'span'}
                        size={size}
                        // className={classes.button}
                        sx={{...sx}}
                        onClick={e => {
                                e.stopPropagation();
                            }}
                    >
                        {text ? text : 'Upload'}
                    </Button>
                }
            </label>
        </div>
    )
}
